import {apiPost} from './client';

export function generateLyrics({occasion, details, musicStyle, currentLyrics, instruction}) {
    return apiPost('/celebs/generate-lyrics', {
        occasion,
        details,
        music_style: musicStyle,
        current_lyrics: currentLyrics || null,
        instruction: instruction || null,
    });
}

export function generateMusic({accountId, musicStyles, occasion, lyrics, details, voice}) {
    return apiPost('/celebs/music/generate-full-direct', {
        account_id: accountId,
        music_styles: musicStyles,
        occasion,
        lyrics,
        details,
        voice: voice || 'mixed',
    });
}
